import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const changeDefaultManagerFormScheme = (t: TFunction) => {
  return Yup.object({
    id: Yup.string().required(t('common:validation_messages.required')),
  })
}

export const changeDefaultManagerFormDefault = {
  id: '',
}
